export default {
      id: "favicon-usage",
      viewBox: "0 0 69.212 70.716",
      url: __webpack_public_path__ + "img/icons.df114aed.svg#favicon",
      toString: function () {
        return this.url;
      }
    }